import { setUi, useUi } from "@app/ui";
import { useSubmitFeedback } from "@repo/components/ctrl/hooks";
import { Button, Group, Modal, Text, Textarea } from "@repo/ui/core";
import { CornerButton, toast } from "@repo/ui/na";
import { useState } from "react";
import { useLocation } from "react-router";

/** Header "Send feedback": a single message posted to `/feedback/mb`. */
export function FeedbackModal() {
  const { feedback } = useUi();
  const close = () => setUi({ feedback: false });
  return (
    <Modal opened={feedback} onClose={close} title="Send feedback" size={520}>
      {feedback && <FeedbackForm close={close} />}
    </Modal>
  );
}

function FeedbackForm({ close }: { close: () => void }) {
  const [msg, setMsg] = useState("");
  const { pathname } = useLocation();
  const { trigger, isMutating, error } = useSubmitFeedback();
  const send = async () => {
    await trigger({ FEEDBACK_INPUT: `${msg}\n\n— page: ${pathname}` });
    toast("Feedback sent", pathname);
    close();
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (msg.trim()) send();
      }}
      style={{ display: "flex", flexDirection: "column", gap: 14 }}
    >
      <Textarea
        data-autofocus
        label="What would make this better?"
        minRows={5}
        autosize
        value={msg}
        onChange={(e) => setMsg(e.currentTarget.value)}
      />
      {error && (
        <Text size="xs" c="var(--na-danger-text)">
          {error.message}
        </Text>
      )}
      <Group justify="space-between" gap={8}>
        <Text size="xs" c="var(--na-fg-muted)" className="na-mono">
          Includes the page path
        </Text>
        <Group gap={8}>
          <Button onClick={close} h={32}>
            Cancel
          </Button>
          <CornerButton type="submit" size="sm" disabled={!msg.trim() || isMutating}>
            Send feedback
          </CornerButton>
        </Group>
      </Group>
    </form>
  );
}
